export enum UsersSortTypes {
  NAME = 'name',
  DELETED_STATUS = 'deleted_status',
  STATUS = 'status',
  DATE = 'createdAt',
}
